import { RequestMainService } from '../request'

export class InvestService {
  static async getProfitPackage(params: { fromDate: string; toDate: string }) {
    return RequestMainService.get('/admin/invest-package-profit', params).then(
      ({ result }) => result?.data || [],
    )
  }

  static async configProfit(params: any) {
    return RequestMainService.post('/admin/invest-package-profit', params)
  }

  static async getPackages() {
    return RequestMainService.get('/admin/invest-packages').then(({ result }) => result?.data || [])
  }

  static async getInvestHistory(payload: any) {
    return RequestMainService.get('/admin/invest-history', payload).then(({ result }) => ({
      count: result.total,
      data: result.data,
    }))
  }


  static async getInvestWithdrawals(payload: any) {

    return RequestMainService.get('/admin/invest-user/withdrawal', payload).then((res)=>res.result)
  }


  static async approveInvestWithdrawal(id: any) {
    return RequestMainService.post(`/admin/invest-user/${id}/withdrawal`, {action: 'APPROVE'}).then((res)=>res.result)
  }
}
